export default __webpack_public_path__ + "static/media/38t.c396d47a.jpg";